Pixlee.module('HorizontalApp.Show', function(Show, App, _Backbone, _Marionette, $) {

    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        regions: {
            widget_header_region: '#widget_header_region',
            interactive_region: '#interactive_region',
            frame: '.horizontal_frame',
        }
    });
    Show.Layout.include(['LayoutHelpers', 'AccessibilityHelpers']);

    Show.PhotoView = App.Views.ItemView.extend({
        getTemplate: function() {
            var desktopPhotoQuality = (App.isDesktop && gon.display_options && gon.display_options.photoQuality) || 'default';
            if (desktopPhotoQuality === 'xl' || desktopPhotoQuality === 'original') {
                return require('../common/templates/v2/_xl_photo_item.jst.ejs');
            }
            return require('../common/templates/v2/_photo_item.jst.ejs');
        },
        className: 'photo_block',
        tagName: 'li',
        behaviors: {
            Reviews: {},
            Share: {},
            Vote: {},
            Lightbox: {},
            UpdateThumbnailCss: {}
        },
        initialize: function() {
            if (this.model.get('is_starred')) {
                this.$el.addClass('starred');
            }
            this.arrowNavigation = false;
        },
        templateHelpers: {
            decodeUtf8: function(string) {
                return App.request('decode:utf8', string);
            }
        }
    });
    Show.PhotoView.include(['PhotoViewHelpers', 'ReviewHelpers']);


    // Photowall View
    Show.HorizontalCollection = App.Views.CollectionView.extend({
        childView: Show.PhotoView,
        className: 'clearfix',
        tagName: 'ul',
        events: {
            'keydown': 'onKeydown',
            'focusin': 'onFocusin'
        },
        behaviors: function() {
            var behaviorHash = {
                CollectionVote: {},
            };

            if (App.isDesktop) {
                behaviorHash.RefreshOnCssGenerated = {};
            }

            // for backwards compatibility with widgets that are already out in the wild
            if (!_.isFalsy(this.options.displayOptions.headerOptions)) {
                behaviorHash.AppendUploaderTiles = {};
            }
            // if there's no upload tiles or if hideIfLessThanIsSet is set, then we need to have the ability to hide empty albums
            var noUploadButton = _.isFalsy(this.options.displayOptions.headerOptions.end_tile_upload_button_background_showHide);
            var setHideIfLessThan = !_.isFalsy(App.displayOptions.get('hideIfLessThan')) || !_.isFalsy(gon.current_account.extra_fields.hideIfLessThan);
            if (noUploadButton || setHideIfLessThan) {
                behaviorHash.HideEmptyAlbumWidget = {};
            }

            return behaviorHash;
        },
        initialize: function() {
            this.leftAlign = this.options.displayOptions.horizontalLayoutLeftAlign || false;
            this.collection.reviewSelectionOptions = {
                currentModelIndex: 0
            };
            this.arrowNavigation = false;
        },
        onShow: function() {
            $('#widget').attr('alt', App.altText);
            if (App.isDesktop) {
                this.setNextPageListener();
            }
        },
        onKeydown: function(e) {
            var keycode = e.keyCode;
            // left or right arrow, go to next or previous slide
            if (keycode === 37 || keycode === 39) {
                keycode === 37 ? this.sly.prev() : this.sly.next();
                this.arrowNavigation = true;
            // tabbing
            } else if (keycode === 9) {
                if (this.arrowNavigation) {
                    // if last keyboard control was arrow key, focus on active photo
                    e.preventDefault();
                    var newPhoto = this.$el.find('.active .img_holder').get(0);
                    newPhoto.focus();
                }
                this.arrowNavigation = false;
            }
        },
        onFocusin: function(e) {
            if (this.usedArrowButtons) {
                e.preventDefault();
                var focusIndex = this.sly.rel.centerItem;
                var newPhoto = this.$el.find('.img_holder').get(focusIndex);
                newPhoto.focus();
            }
            this.usedArrowButtons = false;
        },
        fetchNextPage: function(extraFnc) {
            var _this = this;
            this.isFetching = true;
            this.collection.nextPage({
                success: function(collection) {
                    if (collection.next) {
                        $('.next').removeClass('disabled');
                        $('.next').prop('disabled', false);
                    }
                    _this.isFetching = false;
                    _this.sly.reload({
                        silentScroll: true
                    });
                    if (extraFnc) {
                        extraFnc.call(_this, _this.sly.items[1].center, true);
                    }
                }
            });
        },
        setNextPageListener: function() {
            //only send events on clicks not auto resize
            $('.next, .prev').on('click', function() {
                this.navigateNextPage(true);
            }.bind(this));

            // listen to tab navigation
            document.addEventListener('keydown', function(e) {
                if (e.key === 'Tab') {
                    this.navigateNextPage(false);
                }
            }.bind(this));
        },
        navigateNextPage: function(usedArrows) {
            this.initialLoad = false;
            if (this.collection.length === 1) {
                this.initialLoad = true;
                this.fetchNextPage(this.sly.slideTo);
            }
            this.usedArrowButtons = usedArrows;
        },
        getSlyOptions: function() {
            return  {
                horizontal: 1,
                smart: 1,
                itemNav: this.leftAlign ? 'basic' : 'centered',
                activateOn: 'click',
                activateMiddle: !App.isDesktop ? 0 : 1,
                mouseDragging: !App.isDesktop ? 1 : 0,
                touchDragging: 1,
                releaseSwing: 1,
                startAt: 0,
                scrollBy: App.isMobile ? 1 : 0,
                speed: 300,
                elasticBounds: 1,
                easing: 'easeOutExpo',
                prevPage: $('.prev'),
                nextPage: $('.next')
            };
        },
        forceCenterSly: function(middleItemIndex) {
            // Re-initalizes with forcedCenter and activateMiddle
            var _this = this;
            var horizontalFrame = $('.horizontal_frame');
            this.isFetching = false;
            this.initialLoad = true;
            var options = this.getSlyOptions(middleItemIndex);
            options.itemNav = 'forceCentered';
            options.startAt = middleItemIndex;
            var setAccessibleElements = this.setAccessibleElements.bind(this);

            this.sly = new Sly(horizontalFrame, options, {
                'change': function() {
                    var position = $(this)[0].pos;
                    if (!_this.initialLoad) {
                        if (position.dest > position.cur) {
                            App.commands.execute('nav:right', this.rel, _this.collection);
                        } else {
                            App.commands.execute('nav:left', this.rel, _this.collection);
                        }
                    }

                    if (!_this.initialLoad && position.dest / position.end > 0.6 && !_this.isFetching) {
                        _this.fetchNextPage();
                        _this.initialLoad = true;
                    }
                },
                'move': function() {
                    setAccessibleElements();
                },
            }).init();
            this.setAccessibleElements();
        },
        onDragNav: function(position, e) {
            var ev = !_.isFalsy(e) ? e.type : 'badEvent'; //if no event info, assume it was an invalid interaction
            var userInteractions = ['touchstart', 'touchend', 'touchmove', 'click'];

            //200 is a magic number but it's about 2 photos in the general case. we don't really need to be
            //that accurate here, other than preventing a tiny jolt from firing it off
            if (Math.abs(position.cur - this.oldPosition) < 200 || userInteractions.indexOf(ev) < 0) {
                return;
            } else if (position.cur > this.oldPosition) {
                App.commands.execute('nav:right', this.sly.rel, this.collection);
            } else {
                App.commands.execute('nav:left', this.sly.rel, this.collection);
            }

            this.oldPosition = position.cur;
        },
        initializeSly: function() {
            var _this = this;
            var debouncedDragNav = _.debounce(this.onDragNav.bind(this), 250);
            var setAccessibleElements = this.setAccessibleElements.bind(this);
            if (!this.sly && this.collection.length) {
                var horizontalFrame = $('.horizontal_frame');
                this.sly = new Sly(horizontalFrame, this.getSlyOptions(), {
                    'change': function() {
                        var position = $(this)[0].pos;
                        if (App.isDesktop && !_this.initialLoad) {
                            var navCommand = position.dest > position.cur  ? 'nav:right' : 'nav:left';
                            App.commands.execute(navCommand, this.rel, _this.collection);
                        } else {
                            //some dumb things don't know what event is, so make sure it's defined
                            var eventObj = !_.isFalsy(typeof event) ? event : null;
                            debouncedDragNav(position, eventObj);
                        }

                        if (position.dest / position.end > 0.6 && !_this.isFetching) {
                            if (App.isDesktop && _this.initialLoad) {
                                return;
                            }
                            _this.isFetching = true;
                            _this.collection.nextPage({
                                success: function(collection) {
                                    if (collection.next) {
                                        $('.next').removeClass('disabled');
                                        $('.next').prop('disabled', false);
                                    }
                                    _this.isFetching = false;
                                    _this.sly.reload({
                                        silentScroll: true
                                    });
                                }
                            });
                        }
                    },
                    'move': function() {
                        setAccessibleElements();
                    },
                    'load': function() {
                        //only run these commands during the initial loading event.
                        if (this.loaded && !this.widthAdjusted) {
                            var numberOfItems = _this.sly.items.length - 1;
                            if (numberOfItems) {
                                var lastItem = _this.sly.items[numberOfItems];
                                var maxWidth = lastItem.start + lastItem.size;
                                var position = $(this)[0].pos;
                                if (position.end) {
                                    $('.next').removeClass('disabled');
                                    $('.next').prop('disabled', false);
                                }
                                $('ul.clearfix').width(maxWidth);
                                this.widthAdjusted = true;
                                _this.sly.reload({
                                    silentScroll: true
                                });
                            }
                        } else {
                            this.loaded = true;
                        }
                    }
                }).init();
                this.sly.reload({
                    silentScroll: true
                });
                this.setAccessibleElements();
                if (App.isDesktop &&
                    !gon.display_options.is_interactive &&
                    _.isFalsy(this.options.displayOptions.headerOptions.end_tile_upload_button_background_showHide) &&
                    !this.leftAlign) { // If the gallery is set to left align, dont force center
                    //try catch because IE9 doesn't play nice with sly
                    try {
                        // If there are not enough photos to fill the frame
                        if (this.sly.items[this.sly.items.length - 1].end < 0) {
                            var middleItemIndex = Math.ceil(this.sly.items.length / 2) - 1;
                            this.sly.destroy();
                            delete this.sly;
                            this.forceCenterSly(middleItemIndex);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
            }
        },
        onRender: function() {
            this.isFetching = false;
            this.oldPosition = 0;
            this.initialLoad = true;

            if (this.sly) {
                this.sly.destroy();
                delete this.sly;
            }
            this.initializeSly();
        }
    });
    Show.HorizontalCollection.include(['tabindexHelpers', 'designEditorCollectionHelpers', 'socialShareHelpers']);

    Show.HeaderView = App.Views.ItemView.extend({
        template: require('../common/templates/v2/_header.jst.ejs'),
        id: 'widget_header',
        behaviors: {
            Upload: {},
            ShowPdpCaption: {}
        }
    });

    Show.HeaderView.include(['StandaloneHeaderHelpers']);

});
